import { useEffect } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { getAiChatTitles, getTodaysTotalAiMessageCount } from "../../features/ai/aiSlice"
import AiChatTitleContainer from "../../components/aiChat/AiChatTitleContainer"
import AiChatContainer from "../../components/aiChat/AiChatContainer"

const Container = styled.div`
    width: 100%;

    .wrapper{
      display: flex;
      justify-content: space-between;
      padding: 30px;

    }
`

const AkilliKamyoon = () => {

  const dispatch = useDispatch()


  useEffect(() => {
    dispatch(getTodaysTotalAiMessageCount())
    dispatch(getAiChatTitles())
  },[])


  return (
    <Container>
      <div className="wrapper">
        <AiChatTitleContainer/>   
        <AiChatContainer/>   
      </div>
    </Container>
  )
}

export default AkilliKamyoon